import React, { useEffect, useState } from 'react';

import to from 'await-to-js';

import { CodeSnippetProps } from './CodeSnippet.types';

import { ERROR_MESSAGES } from '../../../core';
import { DOMPurifySanitizedHtmlContent } from '../../DOMPurifySanitizedHtmlContent';

import './CodeSnippet.css';

const CodeSnippet = ({ location: { presignedUrl }, placeholders }: CodeSnippetProps) => {
  const [html, setHtml] = useState<string>();

  useEffect(() => {
    const loadCodeSnippet = async () => {
      if (!presignedUrl) {
        throw new Error(ERROR_MESSAGES.UNAVAILABLE_PRESIGNED_URL);
      }

      const [fetchError, response] = await to(fetch(presignedUrl));

      if (fetchError) {
        throw fetchError;
      }

      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!response) {
        throw new Error(`Unable to fetch code snippet with url=${presignedUrl}`);
      }

      const { ok: isOk, status } = response;

      if (!isOk) {
        throw new Error(`HTTP error with status: ${status}`);
      }

      const [error, code] = await to(response.text());

      let updatedText = code;

      if (placeholders && code) {
        updatedText = Object.keys(placeholders).reduce((accumulator, placeholder) => {
          if (!accumulator.includes(placeholder)) {
            return accumulator;
          }

          return accumulator.replaceAll(placeholder, placeholders[placeholder]);
        }, code);
      }

      if (error) {
        throw error;
      }

      if (!code) {
        throw new Error('Error serializing response');
      }

      setHtml(updatedText);
    };

    loadCodeSnippet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [presignedUrl]);

  if (!html) {
    return null;
  }

  return (
    <div className="ek-code-snippet c-code-snippet">
      <DOMPurifySanitizedHtmlContent html={html} />
    </div>
  );
};

export { CodeSnippet };
